import React from 'react';

import { createClassName } from 'utils/createClassName';

import './avatarStyles.css';

type Props = {
  url: string;
  alt: string;
  size?: 'm' | 's';
};

export const AvatarComponent: React.FC<Props> = (props) => {
  const { url, alt, size = 'm' } = props;

  const className = createClassName('avatar')({ size });

  return <img alt={alt} src={url} className={className} />;
};
